class DividedCollectionLoader {
  constructor() {
    this.init();
  }

  init() {
    const hasCollectionSections = document.querySelector('.collection-section[data-section-tag]');
    if (!hasCollectionSections) {
      return;
    }

    const nextUrlElement = document.querySelector('.pagination-next-url');
    if (nextUrlElement) {
      this.loadNextPage(nextUrlElement.getAttribute('data-next-url'));
    }
  }

  async loadNextPage(nextUrl) {
    try {
      const response = await fetch(nextUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      this.mergeProducts(doc);
      
      const newNextUrlElement = doc.querySelector('.pagination-next-url');
      if (newNextUrlElement) {
        const newNextUrl = newNextUrlElement.getAttribute('data-next-url');
        if (newNextUrl) {
          this.loadNextPage(newNextUrl);
        }
      }
    } catch (error) {
      console.error('Error loading page:', error);
    }
  }

  processLazyImages(item) {
    item.querySelectorAll('picture.lazy-load:not(.loaded)').forEach(pic => {
      pic.querySelectorAll('source').forEach(src => {
        if (src.dataset.srcset) {
          src.srcset = src.dataset.srcset;
          src.removeAttribute('data-srcset');
        }
      });
      const img = pic.querySelector('img');
      if (!img) return;
      if (img.hasAttribute('loading')) img.removeAttribute('loading');
      const url = img.dataset.src || img.src;
      img.src = url;
      img.removeAttribute('data-src');
      pic.classList.add('loaded');
    });
  }

  mergeProducts(newDoc) {
    const newSections = newDoc.querySelectorAll('.collection-section[data-section-tag]');    
    if (newSections.length === 0) {
      return;
    }
    
    newSections.forEach(newSection => {
      const tag = newSection.getAttribute('data-section-tag');
      const existingSection = document.querySelector(`.collection-section[data-section-tag="${tag}"]`);
      
      const newProducts = newSection.querySelector('.collection__grid');
      const newProductItems = newProducts ? newProducts.querySelectorAll('li.grid__item') : [];
      
      if (existingSection) {
        const existingProducts = existingSection.querySelector('.collection__grid');

          if (existingProducts && newProducts) {
            const existingCount = existingProducts.querySelectorAll('li.grid__item').length;

            newProductItems.forEach((item, index) => {
              const newNumber = existingCount + index + 1;
              item.className = item.className.replace(/grid__item \d+/, `grid__item ${newNumber}`);
              item.style.setProperty('--transition-delay', `${newNumber * 0.2}s`);

              const productCard = item.querySelector('.product-card');
              if (productCard) {
                productCard.classList.add('animate-fade-in');
              }
              existingProducts.appendChild(item);
              this.processLazyImages(item);
            });
        }
      } else {
        if (newProducts && newProductItems.length > 0) {
          newProductItems.forEach(item => {
            const productCard = item.querySelector('.product-card');
            if (productCard) {
              productCard.classList.add('animate-fade-in');
            }
          });

          const collectionContainer = document.querySelector('.collection');
          if (collectionContainer) {
            collectionContainer.appendChild(newSection);
            newProductItems.forEach(item => this.processLazyImages(item));
          }
        }
      }
    });
  }
}

// Global function to initialize the loader (can be called after AJAX content replacement)
window.initDividedCollectionLoader = function() {
  const hasCollectionSections = document.querySelector('.collection-section[data-section-tag]');
  if (hasCollectionSections) {
    new DividedCollectionLoader();
  }
};

document.addEventListener('DOMContentLoaded', () => {
  new DividedCollectionLoader();
});
